import styled, { css } from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const Wrapper = styled.div`
  height: 100%;
`;
const gridMixin = css`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(3, 400px);
  width: inherit;
  height: 640px;

  @media (max-width: ${LANDING_BREAKPOINT}) {
    grid-template-columns: auto;
  }
`;

export const DesktopWrapper = styled.div`
  height: 100%;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    .userHotelRecommandations {
      ${gridMixin}
      grid-template-areas:
      'fillCol . .'
      'fillCol . .';
    }
    .default {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(3, 400px);
      width: inherit;
      height: 400px;
      grid-template-areas: '. . .';
    }
    .hotel {
      ${gridMixin}
      grid-template-areas:
      'fillCol . .'
      'fillCol lastItem lastItem';
    }
    .tour {
      ${gridMixin}
      grid-template-areas:
      '. fillCol .'
      '. fillCol .';
    }
    .cruise {
      ${gridMixin}
      grid-template-areas:
      '. fillCol .'
      '. fillCol .';
    }
  }
`;

export const CardWrapper = styled.div<{ gridArea: string }>`
  grid-area: ${({ gridArea }) => gridArea};
`;
export const Container = styled.div`
  height: 100%;
`;
